<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" class="yx-flex-h-start" style="margin-top: 15px;">
                <div>
                    型号：
                    <el-select v-model="searchVal.devModelId" placeholder="设备型号" size="mini" clearable filterable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in devModels"
                                :key="item.id"
                                :label="item.model"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    仓储状态：
                    <el-select v-model="searchVal.devStrStatId" placeholder="仓储状态" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in devStrStats"
                                :key="item.id"
                                :label="item.desc"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    激活状态：
                    <el-select v-model="searchVal.devActStatId" placeholder="激活状态" size="mini" clearable
                               style="width: 150px;margin-right: 15px;">
                        <el-option
                                v-for="item in devActStats"
                                :key="item.id"
                                :label="item.desc"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    入库日期：
                    <el-date-picker
                            v-model="searchVal.purDateScope"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            size="mini"
                            style="width:250px"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </div>
            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">入库</el-button>
                <!--
                <el-button type="danger" icon="el-icon-truck" @click="showAddEmpView">调拨</el-button>
                <el-button type="danger" icon="el-icon-cpu" @click="showAddEmpView">维修</el-button>
                -->
            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="devices"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="selection" align="center"/>
                <el-table-column prop="terSn" label="终端SN" width="150" />
                <el-table-column prop="devModel.model" label="型号" width="100" />
                <el-table-column prop="devModel.type" label="类别" width="100" />
                <el-table-column label="分配状态" width="100" >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.inAgentId===1" color="#FFFFFF">未分配</el-tag>
                        <el-tag type="info" v-else color="#FFFFFF">已分配</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="devStatStorage.desc" label="仓储状态" width="100" />
                <el-table-column prop="devStatActive.desc" label="激活状态" width="100" />
                <el-table-column prop="inAgent.name" label="当前归属" />
                <!--
                <el-table-column prop="inDateTime" label="调拨时间" width="150" />
                -->
                <el-table-column prop="purBatNo" label="入库批次" width="100" />
                <el-table-column prop="purDateTime" width="150" label="入库时间" sortable />
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <div class="yx-flex-v">
                <!--
                <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
                -->
                <el-tag type="info" style="margin-left: 0px;">
                    <i class="header-icon el-icon-info"></i>
                    状态统计：&nbsp;&nbsp;
                    {{totalTxt}}
                </el-tag>
            </div>
            <el-pagination
                    background
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="slot, sizes, prev, pager, next, jumper, total"
                    :pager-count="5"
                    :total="total">
                <!--
                <span>共计{{total}}台&nbsp;&nbsp;</span>
                -->
            </el-pagination>
        </div>

        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                width="60%"
                class="dlg-normal">
            <div style="height: 350px; margin-top: 5px; overflow-y: auto;">
                <el-form :model="devInfoForm" :rules="rules" ref="devInfoForm">
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="入库批次" prop="purBatNo">
                                    <el-input size="small" v-model="devInfoForm.purBatNo" :disabled="true" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="仓库名称" prop="purBatNo222">
                                    <el-input size="small" value="主仓库" :disabled="true" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="仓储状态" prop="purBatNo222">
                                    <el-select v-model="devInfoForm.devStrStat" size="small" :disabled="true"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in devStrStats"
                                                :key="item.id"
                                                :label="item.desc"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="激活状态" prop="purBatNo222">
                                    <el-select v-model="devInfoForm.devActStat" size="small" :disabled="true"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in devActStats"
                                                :key="item.id"
                                                :label="item.desc"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="设备型号" prop="modelId">
                                    <el-select v-model="devInfoForm.modelId" size="small" placeholder="设备型号"
                                               style="width: 100%;">
                                    <el-option
                                                v-for="item in devModels"
                                                :key="item.id"
                                                :label="item.model"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item
                                              v-for="(terSN, index) in devInfoForm.terSNs"
                                              :label="'序列编号'"
                                              :key="terSN.key"
                                              :prop="'terSNs.' + index + '.value'"
                                              :rules="{ required: true, message: '不能为空', trigger: 'blur' }">
                                    <el-input size="small" v-model="terSN.value" :ref="'p'+terSN.key" @keyup.enter.native="addDevInfoInput" placeholder="终端SN，可以使用“-”批量录入号段，例如001-005" />
                                    <el-button style="margin-left: 10px" type="danger" plain size="mini" icon="el-icon-delete" @click.prevent="removeDevInfoInput(terSN)"></el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                      <el-tooltip content="增加序号|号段" placement="top">
                        <el-button type="danger" plain icon="el-icon-plus" @click.prevent="addDevInfoInput"></el-button>
                       </el-tooltip>
                        <el-tag type="info" style="margin-left: 10px">
                            <i class="header-icon el-icon-info"></i>
                            预入库：&nbsp;&nbsp;
                            型号：{{devMod}}&nbsp;&nbsp;
                            数量：{{devCnt}}&nbsp;&nbsp;
                        </el-tag>
                    </div>
                    <div>
                        <el-button size="small" @click="showDlg = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="dlgCommit">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>

    </div>

</template>

<script>

    import {
        //URL_DEV_ACT_STATS,
        URL_DEV_MODELS,
//        URL_DEV_STR_STATS,
        URL_DATA_PURBATNO
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";

export default {
        name: "DevPurch",
    components: {AreaSelect},
    data() {
            return {
                title: '',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showFV: false,
                dialogVisible: false,
                loading: false,
                total: 0,
                totalTxt:'',
                page: 1,
                size: 10,
                titleDlg: '',
                showDlg: false,
                devices: [],
                devModels: [],
                devStrStats: [],
                devActStats: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    purDateScope: null,
                    devModelId: null,
                    devStrStatId: null,
                    devActStatId: null
                },
                keywordList: [
                    {id:"inAgentName",name:"所属服务商"},
                    {id:"terSn",name:"终端SN"}
                ],
                devMod: '',
                devCnt: 0,
                devInfoForm: {
                    modelId: null,
                    terSNs: [{value:'',key:Date.now()}],
                    purBatNo:null,
                    purDateTime:null,
                    devStrStat:1,
                    devActStat:1,
                    inAgentId:1,
                    inAgentName:null,
                    inDateTime:null,
                    devModel:{},
                    devStatActive:{},
                    devStatStorage:{},
                    inAgent:{}
                },
                insDevInfoList: [],
                insDevInfo: {
                    modelId:null,
                    terSn:null,
                    purBatNo:null,
                    devStrStat:null,
                    devActStat:null
                },
                rules: {
                    purBatNo: [{required: true, message: '请输入purBatNo', trigger: 'blur'}],
                    purBatNo222: [{required: true, message: '请输入purBatNo222', trigger: 'blur'}],
                    modelId: [{required: true, message: '请输入modelId', trigger: 'blur'}],
                }
            }
        },
        watch:{
            devInfoForm: {
                handler:function(val) {
                    if(this.devInfoForm.terSNs.length>0) {
                        let sns = this.devInfoForm.terSNs;
                        this.devCnt = 0;
                        this.devMod = '';
                        for(let i=0;i<this.devModels.length;i++) {
                            if(this.devInfoForm.modelId==this.devModels[i].id) {
                                this.devMod = this.devModels[i].model;
                                break;
                            }
                        }
                        for(let i=0;i<sns.length;i++) {
                            if(sns[i].value) {
                                if(sns[i].value.indexOf("-")!=-1) {
                                    let sn_sn = sns[i].value.split("-");
                                    if(sn_sn.length==2 && sn_sn[0].length==sn_sn[1].length) {
                                        let len = sn_sn[0].length;
                                        let sn1 = sn_sn[0];
                                        let sn2 = sn_sn[1];
                                        let idx = -1;
                                        for(let j=len-1;j>=0;j--) {
                                            if( sn1.charCodeAt(j)>=48 && sn1.charCodeAt(j)<=57
                                                && sn2.charCodeAt(j)>=48 && sn2.charCodeAt(j)<=57 ) {
                                                idx = j;
                                            }
                                            else break;
                                        }
                                        if(idx>=0) {
                                            sn1 = sn1.substring(idx);
                                            sn2 = sn2.substring(idx);
                                            let snc = sn2-sn1;
                                            if(snc==0) this.devCnt++;
                                            else if(snc>0) this.devCnt += sn2-sn1+1;
                                        }
                                    }
                                }
                                else {
                                    this.devCnt++;
                                }
                            }
                        }
                    }
                },
                deep:true
            }
        },
        mounted() {
            this.initDevices();
            this.getRequest(URL_DEV_MODELS).then(resp => { if (resp) this.devModels = resp.data });
//            this.getRequest(URL_DEV_STR_STATS).then(resp => { if (resp) this.devStrStats = resp.data });
            //this.getRequest(URL_DEV_ACT_STATS).then(resp => { if (resp) this.devActStats = resp.data });
        },
        methods: {
            addDevInfoInput() {
                let key = Date.now();
                this.devInfoForm.terSNs.push({
                    value: '',
                    key: key
                });
                //console.log(key)
                //this.$refs['p'+key][0].focus();
            },
            removeDevInfoInput(item) {
                let index = this.devInfoForm.terSNs.indexOf(item);
                if (index !== 0) {
                    this.devInfoForm.terSNs.splice(index, 1);
                }
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.initDevices();
            },
            initDevices() {
                this.loading = true;
                let urlParam = '?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.devModelId) {
                    urlParam += '&modelId=' + this.searchVal.devModelId;
                }
                if (this.searchVal.devStrStatId) {
                    urlParam += '&devStrStat=' + this.searchVal.devStrStatId;
                }
                if (this.searchVal.devActStatId) {
                    urlParam += '&devActStat=' + this.searchVal.devActStatId;
                }
                if (this.searchVal.purDateScope) {
                    urlParam += '&purDateScope=' + this.searchVal.purDateScope;
                }

                this.getRequest("/dev/devInfoAll" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devices = resp.data;
                        this.total = resp.total;
                    }
                });

                this.totalTxt = '';
                this.getRequest("/dev/devInfoStatActTotal" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        let ar = resp.data;
                        this.totalTxt = ar[0];
                    }
                });

            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initDevices();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initDevices();
            },
            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            exportData() {
                console.log(this.devModels);
            },
            showAddEmpView() {
            },
            viewAdd() {
                this.titleDlg = '设备入库';
                this.insDevInfoList = [];
                this.devInfoForm.modelId = null;
                this.devInfoForm.terSNs = [{value:'',key:Date.now()}];
                this.getPurBatNo();
                this.showDlg = true;
            },
            getPurBatNo() {
                this.getRequest(URL_DATA_PURBATNO).then(resp => { if (resp) this.devInfoForm.purBatNo = resp.obj.no });
            },
            dlgCommit() {
                this.insertDevInfo();
            },
            insertDevInfo() {
                let cnt = this.devInfoForm.terSNs.length;
                if(cnt<=0) return;

                for(let i=0;i<cnt;i++) {
                    let snTemp = this.devInfoForm.terSNs[i].value;
                    if(snTemp.indexOf("-")!=-1) {
                        let sn_sn = snTemp.split("-");
                        if(sn_sn.length==2 && sn_sn[0].length==sn_sn[1].length) {
                            let len = sn_sn[0].length;
                            let sn1 = sn_sn[0];
                            let sn2 = sn_sn[1];
                            let idx = -1;
                            for(let j=len-1;j>=0;j--) {
                                if( sn1.charCodeAt(j)>=48 && sn1.charCodeAt(j)<=57
                                    && sn2.charCodeAt(j)>=48 && sn2.charCodeAt(j)<=57 ) {
                                    idx = j;
                                }
                                else break;
                            }
                            if(idx>=0) {
                                let sn1Header = sn1.substring(0,idx);
                                let sn2Header = sn2.substring(0,idx);
                                if(sn1Header==sn2Header) {
                                    sn1 = sn1.substring(idx);
                                    sn2 = sn2.substring(idx);
                                    let snc = sn2-sn1;
                                    for(let k=0;k<=snc;k++) {
                                        let sn = Number.parseInt(sn1)+k;
                                        this.insDevInfo = {};
                                        this.insDevInfo.modelId = this.devInfoForm.modelId;
                                        this.insDevInfo.purBatNo = this.devInfoForm.purBatNo;
                                        this.insDevInfo.devStrStat = this.devInfoForm.devStrStat;
                                        this.insDevInfo.devActStat = this.devInfoForm.devActStat;
                                        this.insDevInfo.terSn = sn1Header+sn;
                                        this.insDevInfoList.push(this.insDevInfo);
                                    }
                                }
                                else {
                                    // 前段不同
                                }
                            }
                        }
                    }
                    else {
                        this.insDevInfo = {};
                        this.insDevInfo.modelId = this.devInfoForm.modelId;
                        this.insDevInfo.purBatNo = this.devInfoForm.purBatNo;
                        this.insDevInfo.devStrStat = this.devInfoForm.devStrStat;
                        this.insDevInfo.devActStat = this.devInfoForm.devActStat;
                        this.insDevInfo.terSn = this.devInfoForm.terSNs[i].value;
                        this.insDevInfoList.push(this.insDevInfo);
                    }
                }

//                console.log(JSON.stringify(this.insDevInfoList));
//                return;

                this.postRequest("/dev/addDevInfo", this.insDevInfoList).then(resp => {
                    if (resp) {
                        this.initDevices();
                        this.showDlg = false;
                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>
